import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'loyal-react'
import Modal from 'react-awesome-modal'

const ModalConfirmRecharge = props => (
  <Modal width='600'
    height='90%' effect='fadeInUp' visible={props.show}>
    <Fragment>
      <div className='modal-wrapper col-11 mx-auto bg-white radius px-2 py-3 border-bottom-lg border-color-featured'>
        <div className='row'>
          <div className='col-12'>
            <p className='txt-body-sm'>
              Você está realizando uma recarga no valor de <strong> {props.creditValue ? `R$ ${props.creditValue.toLocaleString('pt-br', {
                minimumFractionDigits: 2
              })}` : ''}</strong> para o número <strong>({props.areaCode || 'xx'}) {props.phoneNumber || 'xxxxx-xxxx'}</strong>.
            </p>
            <p className='txt-body-sm mt-1'>
              As recargas de celular são válidas apenas para celulares de planos pré-pago ou controle.
            </p>
            <p className='txt-body-sm mt-1'>
              Confira o número digitado e operadora escolhida antes de finalizar.
            </p>
          </div>
          <div className='col-12 col-md-6  mt-2'>
            <Button
              className='btn btn-sm py-2'
              onClick={e => props.onClose()}
              text='Cancelar'
            />
          </div>
          <div className='col-12 col-md-6  mt-2'>
            <Button
              id={'Confirm-recharge'}
              name={'Confirm'}
              className='btn btn-featured py-2'
              text='Confirmar Recarga'
              onClick={e => props.finalizeOrder()}
              loading={props.loadingFinalizeOrder}
            />
          </div>
        </div>
      </div>
    </Fragment>
  </Modal>
)

ModalConfirmRecharge.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  finalizeOrder: PropTypes.func,
  loadingFinalizeOrder: PropTypes.func,
  areaCode: PropTypes.string,
  phoneNumber: PropTypes.string,
  creditValue: PropTypes.string
}

export default ModalConfirmRecharge



// WEBPACK FOOTER //
// ./src/features/CellphoneRecharge/ModalConfirmRecharge/ModalConfirmRecharge.js